import React from 'react';

import Hero from '../Components/HeroSection/HeroSection';
import ProblemSection from '../Components/ProblemSection/ProblemSection'
import WhatComesNext from '../Components/WhatComesNext/WhatComesNext';
import OurThesis from '../Components/OurThesis/OurThesis';
import Invest from '../Components/invest/Invest';
import ShortCourses from '../Components/ShortCourses/ShortCourses';
import Provide from '../Components/provide/Provide';
import EDForm from '../Components/EdForm/EDForm';



function Home() {
  return (
   <>
   <Hero/>
   <ProblemSection/>
   <WhatComesNext/>
   <OurThesis/>
   {/* <Invest/>
   <ShortCourses/> */}
 {/* <Provide/> */}
 {/* <EDForm/> */}
 
   </>
  );
}

export default Home;